import { render } from "./Tarrifs.vue?vue&type=template&id=2411d080"
import script from "./Tarrifs.vue?vue&type=script&lang=js"
export * from "./Tarrifs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__